
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emailsent",
      function () {
        return require("private-next-pages/emailsent.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emailsent"])
      });
    }
  